export default __webpack_public_path__ + "static/media/starburst.ad2649fd.png";